import { Text } from "@mantine/core";
import { FC } from "react";
import line from "@funded-here-interface/common/src/assets/Line6.png";
import { Button } from "@funded-here-interface/common";
import { useNavigate } from "react-router-dom";
import { RootState, store, persistor } from "../../store";
import { useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import { useStyle } from "./WelcomeIssuingSPV.styles";
import useLogoutMutation from "../../hooks/useLogout";
import { useQueryClient } from "react-query";
import { performLogoutCleanup } from "@funded-here-interface/common/src/services/standardizedLogout";
import { resetAuthState } from "@funded-here-interface/common/src/features/auth/authSlice_Investor";
import OnboardingLayout from "../../layouts/OnboardingLayout/OnboardingLayout";

const WelcomeIssuingSPV: FC = () => {
  const { classes } = useStyle();
  const Navigate = useNavigate();
  const queryClient = useQueryClient();
  const token = useSelector((state: RootState) => state.auth.token);
  const logoutMutation = useLogoutMutation();

  const handleSubmit = () => {
    Navigate("/supplier-biz-profile");
  };

  const handleLogout = () => {
    logoutMutation.mutate(
      { token },
      {
        onSuccess: () => {
          performLogoutCleanup({
            navigate: Navigate,
            store,
            resetAuthAction: resetAuthState,
            persistor,
            queryClient,
          });
        },
        onError: (e) => {
          toast.error((e as Error).message);
        },
      }
    );
  };

  return (
    <OnboardingLayout
      step={0}
      content={
        <div className={classes.stepContent} style={{ marginTop: "0px" }}>
          <Text className={classes.headerText}>Welcome to FundedHere!</Text>
          <Text className={classes.instruction} style={{ marginTop: "10px" }}>
            As part of our commitment to maintaining the highest standards of
            security and compliance, we kindly request you to submit your
            details.
          </Text>

          <Text className={classes.subHeading}>Steps (approx 10 minutes)</Text>
          <div className={classes.stepsToComplete}>
            <div className={classes.progress}>
              <div className={classes.eclipse}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                >
                  <circle cx="5" cy="5" r="5" fill="#151515" />
                </svg>
              </div>
              <div className={classes.line}>
                <img src={line} alt="line" />
              </div>
            </div>
            <ol
              style={{
                paddingLeft: "50px",
                paddingTop: "0px",
                marginTop: "30px",
              }}
            >
              <li>
                <Text className={classes.list}>Business profile</Text>
              </li>
              <li>
                <Text className={classes.list}>Bank details</Text>
              </li>
            </ol>
          </div>
          <div className={classes.buttonDiv}>
            <div className={classes.buttonWrapper}>
              <Button
                onClick={handleSubmit}
                textColor="#ffff"
                backgroundColor="#338F86"
                children="Let's Go"
                width="254px"
              />
            </div>
            <ToastContainer />
            <div className={classes.buttonWrapper}>
              <Button
                onClick={handleLogout}
                backgroundColor="#ffff"
                textColor="#338F86"
                children="I'll do it later"
                border="1px solid #338F86"
                width="300px"
              />
            </div>
          </div>
        </div>
      }
    />
  );
};

export default WelcomeIssuingSPV;
